import { ReduxDispatch } from "models/ReduxProps";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import NuovoAppuntamentoFormModel from "../agenda/models/NuovoAppuntamentoFormModel";
import AppuntamentoModel from "./models/AppuntamentoModel";
import AgendaEffect, { ISaveAppuntamentoRequest } from "./AgendaEffect";
import GetAppuntamentiModel from "./models/GetAppuntamentiModel";

type ActionUnion =
    | undefined
    | HttpErrorResponseModel
    | NuovoAppuntamentoFormModel
    | AppuntamentoModel
    | GetAppuntamentiModel;

export default class AgendaAction {
    public static readonly REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET: string =
        "AgendaAction.REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET";
    public static readonly REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO: string =
        "AgendaAction.REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO";
    public static readonly REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO: string =
        "AgendaAction.REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO";
    public static readonly REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_GET_APPUNTAMENTI: string =
        "AgendaAction.REQUEST_SIMULAZIONE_GET_APPUNTAMENTI";
    public static readonly REQUEST_SIMULAZIONE_GET_APPUNTAMENTI_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_GET_APPUNTAMENTI_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_DELETE_APPUNTAMENTO: string =
        "AgendaAction.REQUEST_SIMULAZIONE_DELETE_APPUNTAMENTO";
    public static readonly REQUEST_SIMULAZIONE_DELETE_APPUNTAMENTO_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_DELETE_APPUNTAMENTO_FINISHED";

    public static readonly REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI: string =
        "AgendaAction.REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI";
    public static readonly REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI_FINISHED: string =
        "AgendaAction.REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI_FINISHED";

    public static setNuovoAppuntamentoForm(form: NuovoAppuntamentoFormModel): any {
        return ActionUtility.createAction(AgendaAction.REQUEST_SIMULAZIONE_NUOVO_APPUNTAMENTO_FORM_SET_FINISHED, form);
    }

    public static resetNuovoAppuntamento(): any {
        return ActionUtility.createAction(AgendaAction.REQUEST_SIMULAZIONE_RESET_NUOVO_APPUNTAMENTI_FINISHED);
    }

    public static salvaAppuntamento(request: ISaveAppuntamentoRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AppuntamentoModel>(
                dispatch,
                AgendaAction.REQUEST_SIMULAZIONE_SALVA_APPUNTAMENTO,
                AgendaEffect.salvaAppuntamento,
                request
            );
        };
    }

    public static updateAppuntamento(request: ISaveAppuntamentoRequest): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<AppuntamentoModel>(
                dispatch,
                AgendaAction.REQUEST_SIMULAZIONE_UPDATE_APPUNTAMENTO,
                AgendaEffect.updateAppuntamento,
                request
            );
        };
    }

    public static getAppuntamenti(data: string): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<GetAppuntamentiModel>(
                dispatch,
                AgendaAction.REQUEST_SIMULAZIONE_GET_APPUNTAMENTI,
                AgendaEffect.getAppuntamenti,
                data
            );
        };
    }

    public static deleteAppuntamento(id: number): any {
        return async (dispatch: ReduxDispatch<ActionUnion>): Promise<void> => {
            await ActionUtility.createThunkEffect<GetAppuntamentiModel>(
                dispatch,
                AgendaAction.REQUEST_SIMULAZIONE_DELETE_APPUNTAMENTO,
                AgendaEffect.deleteAppuntamento,
                id
            );
        };
    }
}
